// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"cb657fbd1710c9318723","303":"8fc90ef547872f3867e8","495":"b1f1a9c2ffbda583c989"}[chunkId] + ".js";
};